const COLUMN_ITEM_SIZE_SMALL = '15em'
const COLUMN_ITEM_SIZE_BIG = '20em'

export {
  COLUMN_ITEM_SIZE_SMALL,
  COLUMN_ITEM_SIZE_BIG
}
